import React from 'react'
import PropTypes from 'prop-types'
import { isAgreeAndDonateLabel } from '../utility/localizer.js';

class GuestSubmitButton extends React.Component {

	getDonateButtonLabel = () => {
		let {
			passwordFieldsOpen = false,
			labels: {
				donatenow,
				donatenowrec,
				agreeanddonate,
				agreeanddonatenowrec
			} = {},
			country
		} = this.props;
		const useAgreeAndDonateLabel = passwordFieldsOpen || isAgreeAndDonateLabel(country);

		let donateLabel;
		if (this.props.isRecurring) {
			donateLabel = donatenowrec;

			if (useAgreeAndDonateLabel) {
				donateLabel = agreeanddonatenowrec;
			}
			donateLabel = donateLabel && donateLabel.replace('{amount}', this.props.amount);
		} else {
			donateLabel = donatenow;
			if (useAgreeAndDonateLabel) {
				donateLabel = agreeanddonate;
			}
		}

		return donateLabel;
	}

	render () {
		return (
			<div style={{ maxWidth: 360, margin: '20px auto 0px' }}>
				<button type="button"
					disabled={this.props.disabled}
					style={{ marginBottom: '0px', fontFamily: 'pp-sans-big-medium' }}
					id="guestPaymentBtn"
					className="vx_btn vx_btn-block"
					onClick={(e) => {
						this.props.handleClick(e)
					}}>
					{this.getDonateButtonLabel()}
				</button>
			</div>
		);
	}
}

GuestSubmitButton.propTypes = {
	labels: PropTypes.object,
	amount: PropTypes.string,
	country: PropTypes.string,
	disabled: PropTypes.bool,
	isRecurring: PropTypes.bool,
	handleClick: PropTypes.func,
	passwordFieldsOpen: PropTypes.bool,
};

export default GuestSubmitButton



// WEBPACK FOOTER //
// ./components/guest-submit-button.js